<template>
  <div class="auth-form w-100">
    <template v-if="isSuccess">
      <v-sheet class="forgot-password-success-card pa-6 text-center rounded-lg" elevation="0">
        <v-icon
          class="forgot-password-success-card__icon mb-3"
          :icon="envelopeIcon"
          size="40"
          aria-hidden="true"
        />
        <h2 class="forgot-password-success-card__title text-h6 font-weight-semibold mb-2">
          Solicitud enviada
        </h2>
        <p class="forgot-password-success-card__text text-body-2 mb-4">
          Si sus datos son correctos, recibirá instrucciones para restablecer
          su contraseña en el correo electrónico registrado.
        </p>
        <v-btn
          block
          color="primary"
          @click="goBack"
        >
          Volver al inicio
        </v-btn>
      </v-sheet>
    </template>

    <template v-else>
      <v-btn
        variant="text"
        class="text-medium-emphasis px-0 mb-2 justify-start"
        :prepend-icon="backIcon"
        @click="$emit('back')"
      >
        Volver al inicio
      </v-btn>

      <h1 class="auth-form__title text-h5 font-weight-semibold mb-2">
        Restablecer contraseña
      </h1>
      <p class="text-body-2 text-medium-emphasis mb-6">
        Ingrese sus datos y le enviaremos instrucciones para restablecer su
        contraseña.
      </p>

      <v-form ref="authForm" @submit.prevent="handleSubmit">
        <div class="stack-fields">
          <TipoDocumentoTextField
            v-model:tipo-id="documentTipoId"
            v-model:numero="documentNumber"
            native-autocomplete="off"
            :rules-nro-doc="[rules.required]"
          />

          <div class="d-flex flex-wrap gap-3 mt-4">
            <v-btn variant="outlined" type="button" @click="$emit('back')">
              Cancelar
            </v-btn>
            <v-btn
              type="submit"
              color="primary"
              class="flex-grow-1"
              min-width="120"
              :loading="isLoading"
            >
              {{ isLoading ? 'Enviando...' : 'Restablecer' }}
            </v-btn>
          </div>
        </div>
      </v-form>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import enums from '../../utils/enums'
import rules from '../../utils/helpers/rules'
import TipoDocumentoTextField from '../shared/TipoDocumentoTextField.vue'

export default {
  name: 'ForgotPasswordAuthForm',
  components: { TipoDocumentoTextField },
  props: {
    hospitalConfig: {
      type: Object,
      required: true,
    },
  },
  emits: ['back'],
  data() {
    return {
      backIcon: enums.icons.BACK,
      envelopeIcon: enums.icons.ENVELOPE,
      documentTipoId: null,
      documentNumber: '',
      isLoading: false,
      isSuccess: false,
      rules,
    }
  },
  methods: {
    ...mapActions({
      setAlert: 'alerts/setAlert',
      solicitarRestablecimiento: 'auth/solicitarRestablecimiento',
    }),
    goBack() {
      this.isSuccess = false
      this.documentTipoId = null
      this.documentNumber = ''
      this.$emit('back')
    },
    async handleSubmit() {
      console.log('handleSubmit')
      const { valid } = await this.$refs.authForm.validate()
      if (!valid) return
      if (this.documentTipoId == null) {
        this.setAlert({
          type: 'warning',
          message: 'Seleccione el tipo de documento.',
        })
        return
      }
      this.isLoading = true
      const payload = {
        tdId: this.documentTipoId,
        nroDoc: this.documentNumber,
      }
      try {
        const result = await this.solicitarRestablecimiento(payload)
        if (result?.ok) {
          this.setAlert({
            type: 'success',
            message:
              'Correo enviado éxitosamente.',
          })
          this.isSuccess = true
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.auth-form {
  max-width: 28rem;
}
.auth-form__title {
  color: var(--portal-primary);
}
.forgot-password-success-card {
  background-color: rgba(var(--v-theme-primary), 0.12) !important;
}
.forgot-password-success-card__icon {
  color: var(--portal-primary);
  opacity: 0.95;
}
.forgot-password-success-card__title,
.forgot-password-success-card__text {
  color: var(--portal-primary);
}
.stack-fields > * + * {
  margin-top: 1.25rem;
}
.gap-3 {
  gap: 0.75rem;
}
</style>
